import * as React from 'react';
import { Column, Cell } from 'fixed-data-table-2';

import { getNewSelection } from './DataGrid.selection';

const SELECTED_ICON = 'fa fa-check';
const NOT_SELECTED_ICON = 'fa fa-square-o';
const ICON_COLOR = '#6a6c6f';

interface SelectorColumnParams<T> {
	allItems: T[];
	selectedItems: T[];
	isSelected: (item: T) => boolean;
	setSelectedItems: (newSelection: T[]) => void;
}

export function createSelectorColumn<T>({ allItems, selectedItems, isSelected, setSelectedItems }: SelectorColumnParams<T>) {

	const areAllItemsSelected = () => selectedItems.length === allItems.length && allItems.length > 0;
	const headerIcon = areAllItemsSelected() ? SELECTED_ICON : NOT_SELECTED_ICON;

	const onHeaderClick = (e: React.MouseEvent<any>) => {
		e.preventDefault();
		e.stopPropagation();

		if (areAllItemsSelected()) {
			setSelectedItems([]);
		} else {
			setSelectedItems(allItems);
		}
	};

	const header = <Cell className='text-center' onClick={onHeaderClick} style={{ color: ICON_COLOR }}>
		<span className={headerIcon}></span>
	</Cell>;

	const cell = ({ rowIndex }: any) => {
		const checked = isSelected(allItems[rowIndex]);

		const onCellClick = (e: React.MouseEvent<any>) => {

			e.preventDefault();
			e.stopPropagation();

			const newSelection = getNewSelection({
				allItems,
				selectedItems,
				multiSelect: true,
				clickedRowIndex: rowIndex,
				ctrlKey: true,
				shiftKey: e.shiftKey,
			});

			setSelectedItems(newSelection);
		};

		const cellIcon = checked ? SELECTED_ICON : NOT_SELECTED_ICON;

		return <Cell onClick={onCellClick} className='text-center' style={{ color: ICON_COLOR }}>
			<span className={cellIcon}></span>
		</Cell>;
	};

	return <Column key='selector_column'
		width={35} flexGrow={0} fixed={true}
		allowCellsRecycling={true}
		header={header} cell={cell} />;
}
